import { apiConfig } from "./config";

export const goftinoApi = {
  updateId: async (goftinoId: any) => {
    const response = await apiConfig.patch(
      `/api/front/chef/set-goftino-id/${goftinoId}`
    );
    return response;
  },
};
